import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { PhCheckCircle, PhInfo, PhWarning, PhWarningOctagon, PhX } from 'ember-phosphor-icons';

interface TioAlertSignature {
  Args: {
    allowDismiss: boolean;
    iconClass?: string;
    onDismiss?: () => void;
    type: string;
  };
  Blocks: {
    header: [];
    body: [];
  };
  Element: HTMLDivElement;
}

export default class TioAlertComponent extends Component<TioAlertSignature> {
  @tracked alertIsOpen = true;

  onDismissAlert = () => {
    this.alertIsOpen = false;
    this.args.onDismiss?.();
  };

  get alertClass() {
    type AlertType = keyof typeof alertClass;

    const alertClass = {
      error: 'red',
      info: 'blue',
      primary: 'violet',
      success: 'green',
      warning: 'yellow',
    };
    const type = Object.prototype.hasOwnProperty.call(alertClass, this.args.type)
      ? (this.args.type as AlertType)
      : 'info';

    return alertClass[type];
  }

  get alertIcon() {
    const alertIcons = {
      error: PhWarningOctagon,
      info: PhInfo,
      success: PhCheckCircle,
      warning: PhWarning,
    };
    // @ts-expect-error: not sure
    return alertIcons[this.args.type] || PhInfo;
  }

  <template>
    {{#if this.alertIsOpen}}
      <div
        class="pl-6 pr-5 py-4 flex border border-gray-200 rounded-lg bg-{{this.alertClass}}-50"
        ...attributes
      >
        <this.alertIcon class="pr-6 self-start text-{{this.alertClass}}-400 {{@iconClass}}" />
        <div class="flex-col">
          {{#if (has-block "header")}}
            <div class="text-{{this.alertClass}}-800">
              {{yield to="header"}}
            </div>
          {{/if}}
          {{#if (has-block "body")}}
            <div class="text-{{this.alertClass}}-700">
              {{yield to="body"}}
            </div>
          {{/if}}
        </div>
        <div class="ml-auto">
          {{#if @allowDismiss}}
            <button
              class="text-tio-gray-400 hover:text-tio-gray-500 focus:outline-none focus:text-tio-gray-500 transition ease-in-out duration-150"
              type="button"
              {{on "click" this.onDismissAlert}}
            >
              <span class="sr-only">Dismiss</span>
              <PhX size="16" />
              {{! Icon = Phosphor icon PhX; what size/dynamic rest of component }}
            </button>
          {{/if}}
        </div>
      </div>
    {{/if}}
  </template>
  /**
    HACK so Tailwind will not auto-purge the dynamic classnames generated by the logic above:

    text-red-400
    text-red-700
    text-red-800
    text-blue-400
    text-blue-700
    text-blue-800
    text-yellow-400
    text-yellow-700
    text-yellow-800
    text-green-400
    text-green-700
    text-green-800
    bg-red-50
    bg-blue-50
    bg-yellow-50
    bg-green-50


  */
}
